import { supabase } from '../api/supabase'

// Port helpers for rate-card <-> ports links (20261003); used by components/pricing/CardPortsPicker.

export interface PortOption { id: string; label: string }

const escapeIlike = (term: string) => term.trim().replace(/[%_,()]/g, '')

export async function searchPorts(term: string): Promise<PortOption[]> {
  const cleaned = escapeIlike(term)
  let q = supabase.from('ports').select('id, code, name, un_locode').eq('is_active', true).order('code').limit(50)
  if (cleaned) q = q.or(`name.ilike.%${cleaned}%,code.ilike.${cleaned}%,un_locode.ilike.${cleaned}%`)
  const { data, error } = await q
  if (error) { console.error('[CardPortsPicker] search failed', error); return [] }
  return (data || []).map(p => ({ id: p.id, label: `${p.un_locode || p.code} — ${p.name}` }))
}

export type CardPortsTable = 'pricing_rate_card_ports' | 'supplier_rate_card_ports'

export async function loadCardPorts(table: CardPortsTable, cardId: string): Promise<PortOption[]> {
  const { data: links } = await supabase.from(table).select('port_id').eq('rate_card_id', cardId)
  const ids = (links || []).map(l => l.port_id as string)
  if (ids.length === 0) return []
  const { data: ports } = await supabase.from('ports').select('id, code, name, un_locode').in('id', ids)
  return (ports || []).map(p => ({ id: p.id, label: `${p.un_locode || p.code} — ${p.name}` }))
}

export async function saveCardPorts(table: CardPortsTable, cardId: string, ports: PortOption[]): Promise<void> {
  const { error: delErr } = await supabase.from(table).delete().eq('rate_card_id', cardId)
  if (delErr) throw delErr
  if (ports.length === 0) return
  const { error } = await supabase.from(table).insert(ports.map(p => ({ rate_card_id: cardId, port_id: p.id })))
  if (error) throw error
}

